export default "__VITE_ASSET__DDwM2TQ2__"